import { render, staticRenderFns } from "./team.vue?vue&type=template&id=b1ad3b48&scoped=true"
import script from "./team.vue?vue&type=script&lang=ts"
export * from "./team.vue?vue&type=script&lang=ts"
import style0 from "./team.vue?vue&type=style&index=0&id=b1ad3b48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ad3b48",
  null
  
)

export default component.exports